import DataStructure, { sanitize } from "./DataStructure.js";
import { uid } from "quasar";
import { compact } from "lodash";
import { deepFreeze, formatCurrency } from "../util/misc.js";

export const QUOTE_MISC_ITEM_FIELDS = {
  id: "",
  itemType: "misc",
  line: 0,
  category: "",
  description: "",
  brand: "",
  margin: null,
  cost: null,
  price: null,
  notax: false,
  // Marks the single Shipping/Delivery Charge line. Shipping we bill the
  // customer is pass-through money the company keeps to pay the carrier, so
  // it is excluded from the COMMISSIONABLE total (`total.shipping`) while
  // still counting toward the accounting total the customer pays. Not
  // sensitive — the customer's own copy of the quote may carry it. The
  // internal reason for waiving or reducing the charge deliberately lives on
  // the QUOTE, not here: item fields are copied wholesale into the
  // customer-readable document (see `Quote.toCustomerQuote`), whereas
  // top-level quote fields are stripped by CUSTOMER_QUOTE_FIELDS.
  isShipping: false,
};
deepFreeze(QUOTE_MISC_ITEM_FIELDS);

export default class QuoteMiscItem extends DataStructure {
  constructor(data = {}) {
    data = sanitize(data, QUOTE_MISC_ITEM_FIELDS);

    if (!data.id) {
      data.id = uid().slice(-12);
    }

    super(data);
  }

  // Editing

  get isValid() {
    return (
      Boolean(this.data.description) &&
      this.data.cost !== null &&
      this.data.price !== null &&
      this.data.cost >= 0 &&
      this.data.price >= 0 &&
      (Boolean(this.data.brand) || this.data.cost === 0)
    );
  }

  // Formatting

  get cost() {
    return this.data.cost === null ? null : formatCurrency(this.data.cost);
  }

  get price() {
    return this.data.price === null ? null : formatCurrency(this.data.price);
  }

  summary(length = 200) {
    const description = this.data.description.replace(
      /^\*\*+[^*]+\*\*+\s*/gm,
      ""
    );
    return length === null
      ? description
      : description.slice(0, length) + (description.length > length ? "…" : "");
  }

  toString() {
    return compact([this.data.brand, this.summary()]).join("\n");
  }
}
